import styled from "styled-components";

import Form from "../../components/molecules/Form/Form";

const Wrapper = styled.section`
  margin: -60px 0 100px;
`;

const RequestAQuote = () => {
  return (
    <Wrapper id="requestaquote">
      <Form />
    </Wrapper>
  );
};

export default RequestAQuote;
